import { timeHour, timeDay, timeWeek, timeMonth, timeYear } from 'd3-time';
import { timeFormatLocale } from 'd3-time-format';
import deDE from '@/locale/de-DE.json';
import enCA from '@/locale/en-CA.json';
import enGB from '@/locale/en-GB.json';
import enUS from '@/locale/en-US.json';
import esES from '@/locale/es-ES.json';
import frCA from '@/locale/fr-CA.json';
import frFR from '@/locale/fr-FR.json';
import itIT from '@/locale/it-IT.json';
import nlNL from '@/locale/nl-NL.json';

const { searchParams } = new URL(window.location.href);
const locale = searchParams.get('locale') || 'en-us';
const localeFormats = {
  'de-de': deDE,
  'en-ca': enCA,
  'en-gb': enGB,
  'en-us': enUS,
  'es-es': esES,
  'fr-ca': frCA,
  'fr-fr': frFR,
  'it-it': itIT,
  'nl-nl': nlNL,
};

const localeFormat = localeFormats[locale];
const { format: timeFormat } = timeFormatLocale(localeFormat);

const formatWidth = {
  '%I:%M %p': 60,
  '%b %e': 34,
  '%B': 65,
  '%b': 30,
  '%Y': 30,
  '%b %e, %Y': 63,
};

const inlineYear = (format) => {
  const hasYear = format.includes('%Y');
  // Using a closure to track state of independent ticks.
  let trackYear;

  const formatDate = (d, i) => {
    const year = timeFormat('%Y')(d);
    if (i === 0) {
      // set a baseline
      trackYear = year;
    }

    // if this year is different log the year change and set new baseline
    const yearChange = trackYear !== year;
    if (yearChange) {
      trackYear = year;
    }

    // if the year change happened and the label format doesn't already include a year
    // add the year, otherwise return the original format.

    return yearChange && !hasYear
      ? timeFormat(`${format}|%Y`)(d).replace('|', '\n').trimStart()
      : timeFormat(format)(d).replace(', ', '\n').trimStart();
  };

  return formatDate;
};

const getIntervalByWidth = (width, format) => Math.floor(width / formatWidth[format]);

const time = {
  hour: timeHour,
  day: timeDay,
  week: timeWeek,
  month: timeMonth,
  year: timeYear,
};

const every = (scale) => time[scale].every;

const timeMap = {
  hours: every('hour'),
  days: every('day'),
  weeks: every('week'),
  months: every('month'),
  years: every('year'),
};

export { every, localeFormat, timeMap, timeFormat, getIntervalByWidth, inlineYear };
